import { render, staticRenderFns } from "./SubmitReturnSuccess.vue?vue&type=template&id=544c5134&scoped=true"
import script from "./SubmitReturnSuccess.vue?vue&type=script&lang=ts"
export * from "./SubmitReturnSuccess.vue?vue&type=script&lang=ts"
import style0 from "./SubmitReturnSuccess.vue?vue&type=style&index=0&id=544c5134&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c5134",
  null
  
)

export default component.exports